import moo from "moo";
import { getKeywords } from "./consts";

// Keywords could be ambiguously parsed as part of an identifier so we define them here.
const keywords = getKeywords();
// The lexer contains all our rules.
export const lexer = moo.compile({
    // Symbols
    ws: { match: /[ \t]+/ },
    "@": { match: "@" },
    "#": { match: "#" },
    // Grouping
    "(": { match: "(" },
    ")": { match: ")" },
    "[": { match: "[" },
    "]": { match: "]" },
    ",": { match: "," },
    // Boolean operators
    "&": { match: "&" },
    "|": { match: "|" },
    "^": { match: "^" },
    // Math operators
    add: { match: "+" },
    sub: { match: "-" },
    div: { match: "/" },
    mul: { match: "*" },
    // Comparison operators
    // eslint-disable-next-line @typescript-eslint/camelcase
    not_eq: { match: /<>|!=/ },
    lte: { match: "<=" },
    gte: { match: ">=" },
    lt: { match: "<" },
    gt: { match: ">" },
    // eslint-disable-next-line @typescript-eslint/camelcase
    eq_algebraic: { match: "==" },
    eq: { match: "=" },
    // Empty & Contains
    // eslint-disable-next-line @typescript-eslint/camelcase
    is_empty: { match: "is empty" },
    // eslint-disable-next-line @typescript-eslint/camelcase
    is_not_empty: { match: "is not empty" },
    // eslint-disable-next-line @typescript-eslint/camelcase
    does_not_contain: { match: "does not contain" },
    // Identifiers and keywords
    identifier: {
        match: /\$?[a-z_][@.a-z0-9_]*/,
        /**
         * We define the keywords here so that if they match the full identifier,
         * it will be parsed with the correct type instead of "identifier".
         *
         * Not using this parameter would break names containing keywords.
         *
         * For example the term COLOR should parse as (identifier: "COLOR")
         * instead of (identifier: "COL", or: "OR").
         */
        type: moo.keywords(keywords),
    },
    ...keywords,
    // Numbers
    float: { match: /[0-9]+\.[0-9]+/ },
    uint: { match: /[0-9]+(?!\w)/ },
    word: { match: /[0-9][a-z0-9_]+/ },
    // New line
    nl: { match: /(?:\r\n?|\n)+/, lineBreaks: true },
});
